module.exports = __webpack_public_path__ + "assets/img/big-win.c1e3a3b2.png";